const ENDPOINT = new Map();
ENDPOINT.set('serverDate', '/server/date');
export default ENDPOINT
